// extracted by mini-css-extract-plugin
export default {"container":"SearchTypeToggle-module__container__xIc9S","divider":"SearchTypeToggle-module__divider__N7djI"};